import { render, staticRenderFns } from "./CompanyStepComponent.vue?vue&type=template&id=32f1d1e6&scoped=true"
import script from "./CompanyStepComponent.vue?vue&type=script&lang=js"
export * from "./CompanyStepComponent.vue?vue&type=script&lang=js"
import style0 from "./CompanyStepComponent.vue?vue&type=style&index=0&id=32f1d1e6&prod&lang=scss"
import style1 from "./CompanyStepComponent.vue?vue&type=style&index=1&id=32f1d1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1d1e6",
  null
  
)

export default component.exports